import { STATUS } from "react-joyride";

import { PATHS } from "@/constants/paths";
import type { TCaRow, TUploadRow } from "@/providers/types";

export const NAVIGATION_DELAY_MS = 300;

export const MAIN_SIDEBAR_SCROLL_SELECTOR =
  "[data-testid='main-sidebar-scroll']";

// NOTE: Max time to wait for the step target to be in DOM after route change before showing tooltip.
export const TOUR_TARGET_WAIT_MS = 60_000;

export const TOUR_FINISHED_STATUSES: string[] = [
  STATUS.FINISHED,
  STATUS.SKIPPED,
];

// NOTE: Optional per-route selector to wait for page readiness (e.g. lazy-loaded pages).
// If set, the tour waits for this selector instead of the step target after navigating.
export const TOUR_PAGE_READY_SELECTOR: Record<string, string> = {
  [PATHS.CALL_ASSISTANT]: "#call-assistant-meetings-header",
  [PATHS.UPLOADS]: "#uploads-dropzone-area",
};

// NOTE: Maps tour step targets to the route they require.
// Steps not listed here are visible on all pages (sidebar, user menu, etc.).
export const TOUR_STEP_ROUTE_MAP: Record<string, string> = {
  "#call-assistant-search": PATHS.CALL_ASSISTANT,
  "#call-assistant-sort": PATHS.CALL_ASSISTANT,
  "#call-assistant-filter": PATHS.CALL_ASSISTANT,
  "#call-assistant-meeting-list": PATHS.CALL_ASSISTANT,
  "#call-assistant-live-meeting-btn": PATHS.CALL_ASSISTANT,
  "#call-assistant-calendar-section": PATHS.CALL_ASSISTANT,
  "#uploads-dropzone-area": PATHS.UPLOADS,
  "#uploads-table-area": PATHS.UPLOADS,
};

export const CA_TOUR_ROWS: TCaRow[] = [
  ["#call-assistant-search", "Search", "bottom-start"],
  ["#call-assistant-sort", "Sort", "bottom"],
  ["#call-assistant-filter", "Filter", "bottom"],
  ["#call-assistant-meeting-list", "MeetingList", "top"],
  ["#call-assistant-live-meeting-btn", "LiveMeetingBtn", "left"],
  ["#call-assistant-calendar-section", "CalendarSection", "left"],
];

// NOTE: uploadsTable's `disableFlip` keeps the tooltip above the (often very
// tall) table; without it react-floater would auto-flip below the fold.
export const UPLOADS_TOUR_ROWS: TUploadRow[] = [
  ["#uploads-dropzone-area", "Dropzone", "bottom"],
  ["#uploads-table-area", "Table", "top", { disableFlip: true }],
];
